
import React from 'react'
import { CarIcon, BarChart2, CircleDot } from 'lucide-react'

interface HomePreviewProps {
  children?: React.ReactNode
}

export function HomePreview({ children }: HomePreviewProps) {
  return (
    <div className="absolute inset-0 z-0">
      {/* Preview content with blur */}
      <div className="absolute inset-0 scale-[0.98] blur-md opacity-60">
        {children || <HomePreviewContent />}
      </div>
      
      {/* Overlay for better contrast */}
      <div className="absolute inset-0 bg-white/40 backdrop-blur-md" />
    </div>
  )
}

export const HomePreviewContent = () => (
  <div className="h-full w-full overflow-hidden pointer-events-none">
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="h-8 bg-gray-300 rounded w-1/3" />
      
      {/* Car Card */}
      <div className="bg-white rounded-lg p-4 shadow-sm space-y-4">
        <div className="flex items-start gap-2">
          <div className="h-5 w-5 rounded-full bg-[#c5f74f]" />
          <div className="space-y-2">
            <div className="h-6 bg-gray-300 rounded w-32" />
            <div className="h-4 bg-gray-200 rounded w-24" />
          </div>
        </div>
        <div className="flex gap-4">
          <div className="h-10 bg-gray-100 rounded flex-1" />
          <div className="h-10 bg-gray-100 rounded flex-1" />
          <div className="h-10 bg-gray-100 rounded flex-1" />
        </div>
      </div>

      {/* Stats Widget */}
      <div className="bg-white rounded-lg p-4 shadow-sm">
        <div className="grid grid-cols-3 gap-4">
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-16" />
            <div className="h-6 bg-gray-300 rounded w-20" />
          </div>
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-16" />
            <div className="h-6 bg-gray-300 rounded w-20" />
          </div>
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-16" />
            <div className="h-6 bg-gray-300 rounded w-20" />
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="grid grid-cols-2 gap-2 bg-gray-100 p-1 rounded-lg">
        <div className="h-8 bg-white rounded" />
        <div className="h-8 bg-gray-200 rounded" />
      </div>

      {/* Timeline Items */}
      <div className="space-y-4">
        {[1, 2, 3].map((i) => (
          <div key={i} className="bg-white rounded-lg p-4 shadow-sm space-y-2">
            <div className="h-5 bg-gray-300 rounded w-3/4" />
            <div className="h-4 bg-gray-200 rounded w-1/2" />
          </div>
        ))}
      </div>
    </div>
  </div>
)
